import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class MdiLayoutService {

  basedataExpanded = signal(true);
  planningExpanded = signal(false);
  logisticsExpanded = signal(false);

  compareMode = signal(false);
  syncWindows = signal(false);
}
